var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgAttentionLogo = function SvgAttentionLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#FF4500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3994_5996)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69.9999,
    cy: 70.0026,
    r: 46.6667,
    fill: "#303030",
    fillOpacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 38C52.3121 38 38 52.3134 38 70C38 87.6879 52.3134 102 70 102C87.6879 102 102 87.6866 102 70C102 52.3121 87.6865 38 70 38ZM70 97C55.0759 97 43 84.9231 43 70C43 55.0759 55.0769 43 70 43C84.9241 43 97 55.0769 97 70C97 84.9241 84.923 97 70 97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 64.7891C68.6193 64.7891 67.5 65.9083 67.5 67.2891V83.3882C67.5 84.7689 68.6193 85.8882 70 85.8882C71.3807 85.8882 72.5 84.7688 72.5 83.3881V67.2891C72.5 65.9083 71.3807 64.7891 70 64.7891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 61.7266C71.864 61.7266 73.375 60.2155 73.375 58.3516C73.375 56.4876 71.864 54.9766 70 54.9766C68.136 54.9766 66.625 56.4876 66.625 58.3516C66.625 60.2155 68.136 61.7266 70 61.7266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3994_5996",
    x: 11.2345,
    y: 15.5582,
    width: 117.531,
    height: 117.533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.32099
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.04938
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.71 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3994_5996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3994_5996",
    result: "shape"
  })))));
};
export default SvgAttentionLogo;